import React, { useEffect, useMemo } from 'react';
import './App.scss';
import Layout from 'layout/Layout';
import ReactGA from 'react-ga';
import { getPath } from './util';
import { withRouter, useHistory } from 'react-router-dom';
import { GET_URL_PATH_FIRST_PART } from './constants';
import { MaintenanceProvider } from './contexts/MaintenanceContext';
import MaintenanceGuard from './components/shared/MaintenanceGuard';
import { initTrackingPixels } from './util/trackingManager';
import { adjustService } from './util/adjustInstance';

let template = null;

const App = (props) => {
  const appHistory = useHistory();
  const { location } = props;

  // 🎯 Initialize Adjust once on app startup
  useEffect(() => {
    adjustService.init(
      process.env.REACT_APP_ADJUST_WEB_TOKEN ?? "pd1v46wvh2ww",
      process.env.REACT_APP_REACT_ENV === 'production'
        ? 'production'
        : 'sandbox',
    );
  }, []);

  // 📊 Track page views in Google Analytics whenever the route changes
  useEffect(() => {
    ReactGA.pageview(window.location.pathname);
  }, [appHistory.location.pathname]);

  // 🧭 Determine which layout to render based on URL path
  const path = getPath(location.pathname, GET_URL_PATH_FIRST_PART);

  // 🧩 Choose layout template dynamically
  const layoutTemplate = useMemo(() => {
    switch (path) {
      case 'hawakom-faq':
      case 'loyalty-faq':
      case 'customer-complaints-app':
        template = 'NoHeaderFooter';
        break;
      case 'dashboard':
        template = 'DashboardLayout';
        break;
      case 'payinvoice':
        template = 'FooterAppLayout';
        break;
      default:
        template = 'DefaultLayout';
    }

    return (
      <MaintenanceProvider>
        <MaintenanceGuard>
          <Layout template={template} />

        </MaintenanceGuard>
      </MaintenanceProvider>
    );
  }, [path]);

  // 🎯 Read UTM parameters and trigger the correct tracking pixel
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const utmSource = params.get('utm_source');
    const alreadyTracked = sessionStorage.getItem('trackedSource');

    if (utmSource && utmSource !== alreadyTracked) {
      initTrackingPixels(utmSource);
      sessionStorage.setItem('trackedSource', utmSource);
    }
  }, [location.search]);

  return layoutTemplate;
};

export default withRouter(App);
